import { jsx as _jsx } from "react/jsx-runtime";
import { useUserReleasePhase } from '#pplx/frontend/apps/ask/organization/hooks/useUserReleasePhase.js';
import { useGetCountry } from '#pplx/frontend/apps/ask/queries/cloudflare-queries/useGetCountry.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { FeatureFlagsProvider } from '#pplx/frontend/experimentation/provider.js';
export const ExperimentsProvider = ({ children, hostname, appClientVersion, }) => {
    const { session, status } = useSession();
    const cfCountry = useGetCountry();
    const { effectivePhase } = useUserReleasePhase('experiments-provider');
    return (_jsx(FeatureFlagsProvider, { hostname: hostname, appClientVersion: appClientVersion, session: session ?? undefined, isSessionLoading: status === 'loading', cfCountry: cfCountry, effectivePhase: effectivePhase, children: children }));
};
//# sourceMappingURL=ExperimentsProvider.js.map